import { Section } from './TextSection';
import { SectionBase } from './SectionBase';

export class LineSection extends SectionBase {
    constructor(options: Section) {
        super(options);
    }

    clone() {
        return new LineSection(this.toJSON());
    }

    render(): HTMLDivElement {
        const wrapper = document.createElement('div');
        wrapper.classList.add('wrapper');
        
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', '100%');
        svg.setAttribute('preserveAspectRatio', 'none');
        
        const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.classList.add('section', 'line-section');
        
        // Get line style from properties
        const lineStyle = this.propInfo?.find(p => p.name === 'LineType')?.value || 'horizontal';
    

        const rotation = this.propInfo?.find(p => p.name === 'rotation')?.value || '0';
        //handle value if it is string
        const rotationValue = parseInt(rotation.toString());
        line.style.transform = `rotate(${rotationValue}deg)`; // Rotate the line
        
        // Set coordinates based on line style
        switch(lineStyle) {
            case 'horizontal':
                line.setAttribute('x1', '0');
                line.setAttribute('y1', '50%');
                line.setAttribute('x2', '100%');
                line.setAttribute('y2', '50%');
                break;
            case 'vertical':
                line.setAttribute('x1', '50%');
                line.setAttribute('y1', '0');
                line.setAttribute('x2', '50%');
                line.setAttribute('y2', '100%');
                break;
            case 'diagonal':
                line.setAttribute('x1', '0');
                line.setAttribute('y1', '0');
                line.setAttribute('x2', '100%');
                line.setAttribute('y2', '100%');
                break;
        }

        // Set line attributes
        const strokeColor = this.propInfo?.find(p => p.name === 'strokeColor')?.value || '#000000';
        const strokeWidth = this.propInfo?.find(p => p.name === 'strokeWidth')?.value || '2';
        const fillType = this.propInfo?.find(p => p.name === 'fillType')?.value || 'none';
        line.setAttribute('stroke', strokeColor);
        line.setAttribute('stroke-width', strokeWidth);
        line.setAttribute('stroke-dasharray', fillType);   

        // Store current style for property panel
        line.dataset.lineType = lineStyle;

        svg.appendChild(line);
        wrapper.appendChild(svg);

        return wrapper;
    }
}
